export default "/assets/images/hi-mila-black.png?642cee3d4625fb1a5b1bb643f082b654";